module.exports = __webpack_public_path__ + "static/media/L3_2.9e4ee77a.gif";